import { SelectableItem } from '../common/selectableItem';

export enum ContractAwardType {
    ContractAward = 100,
    ContractRegistry = 200
}

export class ContractAwardEnumsToSelectList {
    static getContractAwardTypes(): Array<SelectableItem<ContractAwardType>> {
        var output = [] as Array<SelectableItem<ContractAwardType>>;

        output.push({ value: ContractAwardType.ContractAward, text: 'High Value' });
        output.push({ value: ContractAwardType.ContractRegistry, text: 'Low Value' });

        return output;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/models/contract.awards/contract.award.enums.ts